import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { compose } from 'recompose'
import queryString from 'query-string'
import { wizard } from 'helpers/decorators'
import {
  Input, Radio, RadioGroup
} from 'components/fields'
import { Title, Note, FormDebug, Button } from 'components/misc'
import { FormattedMessage } from 'react-intl'
import { apiAssessors, apiCodeLists } from 'helpers/decorators/api'
import config from 'config'
import validate from './experience.validation'
import { createInitialValues } from 'models/assessor'
import { assessor } from '../../../../constants/wizards'


const enhance = compose(
  apiCodeLists(['assessorExemptionWWCReasonsTypes'], { public: true }),
  apiAssessors(),
  wizard({
    form: 'assessorRegistration',
    disableHook: true,
    multipage: true,
    validate,
    destroyOnUnmount: false
  }),
  connect(state => ({
    submitFailed: get(state.form, 'assessorRegistration.submitFailed'),
  }), { push })
)

class AssessorExperience extends Component {
  static propTypes = {
    assessor: PropTypes.object,
    push: PropTypes.func,
    handleSubmit: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
    onSubmit: PropTypes.func,
    onLoadAssessor: PropTypes.func,
    initialize: PropTypes.func,
    change: PropTypes.func
  }

  async componentDidMount() {
    const query = queryString.parse(get(this.props, 'location.search'))
    const authCode = get(query, 'authorizationCode')

    if (!authCode) {
      this.props.push(`${config.publicPath}/`)
    }

    const assRes = await this.props.onLoadAssessor(authCode)

    if(get(assRes, 'body')) {
      const initValues = createInitialValues(assRes.body)
      this.props.initialize(initValues)
      this.handleWizardUpdate(get(assRes.body, 'isCompleteRegistration'))
    }
  }


  handleWizardUpdate = isCompleteRegistration => {
    const steps = get(assessor, 'steps')

    const rootPath = get(assessor, 'rootPath')

    if (isCompleteRegistration) {
      this.props.changeWizardActive(steps.activity.id, true)
      this.props.changeWizardNext(steps.experience.id, rootPath + steps.activity.path)
      this.props.change('helpers.firstRegistration', true)
    } else {
      this.props.change('helpers.firstRegistration', false)
    }
  }

  setPrevWorkNo = () => {
    this.props.change('workExperienceLength', null)
  }

  render() {
    const {
      assessor,
      handleSubmit,
      values,
      errors,
      onSubmit
    } = this.props

    const isLoading = get(assessor, 'profile.isLoading')

    return (
      <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.welcome_to_the_orb"
            defaultMessage="Welcome to the Online Record Book"
          />
        </Title>

        <Note lighter margin="0 0 35px 0">
          <FormattedMessage
            id="label.you_are_now_registering_as_assessor"
            defaultMessage="You are now registering to become an Assessor"
          />
        </Note>

        <div className="row">
          <div className="col-xs-12 col-md-8">
            <RadioGroup
              name="previousWorkAsAssessor"
              intlKey="label.assessor_do_you_have_experience"
              label="Do you have any experience working with Award Participants as an Assessor?"
              horizontal
              errors={errors}
            >
              <Radio
                name="previousWorkAsAssessor"
                label="yes"
                value="yes"
                intlKey="label.yes"
              />
              <Radio
                name="previousWorkAsAssessor"
                label="no"
                value="no"
                intlKey="label.no"
                onClick={this.setPrevWorkNo}
              />
            </RadioGroup>
          </div>
        </div>

        {get(values, 'previousWorkAsAssessor') === 'yes' &&
          <div className="row">
            <div className="col-xs-12 col-md-4">
              <Input
                name="workExperienceLength"
                label="How many years/months?"
                intlKey="label.how_many_years"
                type="number"
                min={0}
              />
            </div>
          </div>}

        <FormDebug values={values} errors={errors} />
        <div>
          <Button type="submit" disabled={isLoading}>
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>
      </div>
    )
  }
}

export default enhance(AssessorExperience)
